import { render } from "./ImageCarouselEvent.vue?vue&type=template&id=3c650cf6&scoped=true"
import script from "./ImageCarouselEvent.vue?vue&type=script&lang=js"
export * from "./ImageCarouselEvent.vue?vue&type=script&lang=js"

import "./ImageCarouselEvent.vue?vue&type=style&index=0&id=3c650cf6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c650cf6"]])

export default __exports__